import bookworm from './img/bookworm.png';
import luxury from './img/autoluxury.png';
import finans from './img/finans.png';
import foodies from './img/foodies.png';
import spotify from './img/spotify.png';
import pokemundi from './img/pokemundi.png';
import travel from './img/travelBeyond.png';
import pesqueiro from './img/pesqueiro.png';
import tv from './img/playtv.png';
import myPicture from './img/my-picture.png'
import matte from './img/matte.png'

export const IMAGES = {
  matte,
  myPicture,
  bookworm,
  luxury,
  finans,
  foodies,
  spotify,
  pokemundi,
  travel,
  pesqueiro,
  tv
}

